import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faShoppingCart, faComments, faUsers, faMapMarkerAlt, faBuilding } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";  // Import Link from react-router-dom
import NavigationBar from "../layout/NavigationBar"; // Assuming you have a navigation bar
import Footer from "../layout/footer"; // Assuming you have a footer

function Dashboard() {
  const [data, setData] = useState(null); // For storing the fetched stats
  const [loading, setLoading] = useState(true); // Loading state for API requests
  const [error, setError] = useState(null); // Error state for error handling

  // Fetch data function to get stats
  const fetchData = async () => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL, // Ensure this is set in your .env file
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY, // Use environment variables for sensitive data
          secret: process.env.REACT_APP_SECRET, // Same as above
          method: "getStats", // This should match your backend method name
          module: "user",
        }),
      });

      const result = response.data;
      if (result.statusCode === 200) {
        setData(result.result); // Assuming the data you want is in the 'result' field
      } else {
        setError("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Error fetching data");
    } finally {
      setLoading(false); // Set loading state to false after fetching data
    }
  };

  useEffect(() => {
    fetchData(); // Call the fetchData function when the component mounts
  }, []); // Empty array ensures it runs only once when the component mounts

  // Render loading or error state
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <>
      <div className="wrapper">
        <header>
          <NavigationBar />
        </header>

        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 txt_lft">Dashboard</h1>
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <section className="tp-login-area pt-120 pb-140 p-relative fix">
              <div className="container">
                <div className="row justify-content-center">
                  <div className="col-12">
                    <div className="tp-login-wrapper position-relative">
                      {/* Display the fetched stats in cards */}
                      {data ? (
                        <div className="row mt-45 justify-content-center">
                          {/* Users Card */}
                          <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <a href="/users" target="_blank" className="card-link">
                              <div className="card stats_item users-card">
                                <div className="card-body text-center">
                                  <FontAwesomeIcon icon={faUsers} size="3x" className="text-warning mb-3" />
                                  <h4 className="card-title">Users</h4>
                                  <p className="card-text">{data.totalUsers}</p>
                                </div>
                              </div>
                            </a>
                          </div>

                          {/* Businesses Card */}
                          <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <a href="/businesses" target="_blank" className="card-link">
                              <div className="card stats_item businesses-card">
                                <div className="card-body text-center">
                                  <FontAwesomeIcon icon={faBuilding} size="3x" className="text-danger mb-3" />
                                  <h4 className="card-title">Businesses</h4>
                                  <p className="card-text">{data.totalBusinesses}</p>
                                </div>
                              </div>
                            </a>
                          </div>

                          {/* Geotags Card */}
                          <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <a href="/geotags" target="_blank" className="card-link">
                              <div className="card stats_item geotags-card">
                                <div className="card-body text-center">
                                  <FontAwesomeIcon icon={faMapMarkerAlt} size="3x" className="text-info mb-3" />
                                  <h4 className="card-title">Active Geotags</h4>
                                  <p className="card-text">{data.totalGeotags}</p>
                                </div>
                              </div>
                            </a>
                          </div>
                          {/* Geotags Card */}
                          {/* <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <a href="/geotags" target="_blank" className="card-link">
                              <div className="card stats_item geotags-card">
                                <div className="card-body text-center">
                                  <FontAwesomeIcon icon={faMapMarkerAlt} size="3x" className="text-info mb-3" />
                                  <h4 className="card-title">InActive Geotags</h4>
                                  <p className="card-text">{data.inactiveGeotags}</p>
                                </div>
                              </div>
                            </a>
                          </div> */}

                          {/* Hunted Geotags Card */}
                          <div className="col-12 col-md-6 col-lg-3 mb-4">
                            <a href="/hunted" target="_blank" className="card-link">
                              <div className="card stats_item hunted-card">
                                <div className="card-body text-center">
                                  <FontAwesomeIcon icon={faEye} size="3x" className="text-success mb-3" />
                                  <h4 className="card-title">Hunted</h4>
                                  <p className="card-text">{data.totalOpenedGeotags}</p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      ) : (
                        <div>No data available</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Dashboard;
